import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { storeDetailsEvent } from '../../data-layer/actions.js';
import { getBookAppointmentUrl } from '../../utils/store-utils.js';
import 'lodash/deburr';
import StoreBookAppointmentCTA from './StoreBookAppointmentCTA.js';

const StoreBookAppointmentCTAContainer = (_param)=>{
    var { url , code , globalStoreId , name , town , country , streetName , streetNumber , additionalStreetInfo , postalCode , appointmentTypeId  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "url",
        "code",
        "globalStoreId",
        "name",
        "town",
        "country",
        "streetName",
        "streetNumber",
        "additionalStreetInfo",
        "postalCode",
        "appointmentTypeId"
    ]);
    const { locale , getLabel  } = useIntl();
    const { isMultilingualEnabled , featureConfigs  } = useFeatureToggles();
    const { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } = featureConfigs;
    const location = getBookAppointmentUrl(url, {
        paddedLength: appointmentBookingUrlPaddedLength,
        alternativeUrl: appointmentBookingAlternativeUrl && isMultilingualEnabled ? appointmentBookingAlternativeUrl[locale] : appointmentBookingAlternativeUrl,
        alternativeUrlStores: appointmentBookingAlternativeUrlStores
    })({
        globalStoreId,
        code
    });
    const labels = React.useMemo(()=>({
            caption: getLabel('stores.page.details.action.bookAppointment')
        })
    , [
        getLabel
    ]);
    const onClick = React.useCallback(()=>{
        const dataLayerEvent = storeDetailsEvent({
            interaction: 'book appointment click',
            store: {
                globalStoreId,
                name,
                town,
                country,
                streetName,
                streetNumber,
                additionalStreetInfo,
                postalCode
            }
        });
        if (dataLayerEvent) {
            DataLayer.pushEvent(dataLayerEvent);
        }
        window.location.assign(location);
    }, [
        location,
        globalStoreId,
        name,
        town,
        country,
        streetName,
        streetNumber,
        additionalStreetInfo,
        postalCode, 
    ]);
    return /*#__PURE__*/ React.createElement(StoreBookAppointmentCTA, swcHelpers.extends({}, rest, {
        labels: labels,
        onClick: onClick
    }));
};

export { StoreBookAppointmentCTAContainer as default };
//# sourceMappingURL=StoreBookAppointmentCTAContainer.js.map
